module.exports = "/assets/data/fcdaeec2559eaa8de74eff546ce3c30f-EN7.data.json";